/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dealreview_Nda2Inputs */

const en_coinvestments_dealreview_nda2 = /** @type {(inputs: Coinvestments_Dealreview_Nda2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA`)
};

/**
* | output |
* | --- |
* | "NDA" |
*
* @param {Coinvestments_Dealreview_Nda2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dealreview_nda2 = /** @type {((inputs?: Coinvestments_Dealreview_Nda2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dealreview_Nda2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dealreview_nda2(inputs)
});
export { coinvestments_dealreview_nda2 as "coInvestments_dealReview_nda" }